module.exports = __webpack_public_path__ + "img/RESET_Logo_Tower_hamlets.75bb11c1.jpg";